export default (initialState = {}) => {
  return () => {
    return {
      account_number: "",
      bank_beneficiary_name: "",
      branch_address: "",
      ifsc_code: "",
      bank_name: "",
      code: "",
      is_primary: true,
      status_cd: "unverified",
      reason: "",
      file: null,
      file_category: "",
      file_type: "",
      shop_name: "",
      document_id: "",
      file_id: "",
      ...initialState,
    };
  };
};
